import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 15,
		stroke: "#FE5D7C",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.9353 10.3541C20.4075 9.88198 21.1738 9.88198 21.6462 10.3541C22.1182 10.8262 22.118 11.5916 21.6462 12.064L17.6813 16.0289L21.5886 19.9361C22.0605 20.4083 22.0605 21.1737 21.5886 21.6461C21.3524 21.8821 21.0425 22.0005 20.7331 22.0006C20.4235 22.0006 20.1138 21.8821 19.8776 21.6461L15.9704 17.7388L12.1218 21.5884C11.8856 21.8245 11.5757 21.9429 11.2663 21.9429C10.9567 21.9429 10.647 21.8245 10.4108 21.5884C9.93886 21.1163 9.93889 20.3509 10.4108 19.8785L14.2604 16.0289L10.3542 12.1217C9.88193 11.6494 9.88193 10.8841 10.3542 10.4117C10.8266 9.9398 11.592 9.93966 12.0642 10.4117L15.9704 14.3189L19.9353 10.3541Z",
		fill: "#FE5D7C"
	})]
});
export default SvgTimeErrorIcon;
